export const updateSpMenuState = (state) => {
	return {
		type: "CHANGE_SP_MENU_STATE",
		isMenuOpen: state
	}
}
